<button type="button" class="btn-reserve " (click)="open()">
      <div class="icon">
          <i class="fa-solid fa-calendar-days"></i>
      </div>
      <span>Reserve Agora</span>
  </button>